export function EyeIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M2.51677 10.5944C2.40328 10.4147 2.34654 10.3248 2.31477 10.1863C2.29091 10.0822 2.29091 9.918 2.31477 9.8139C2.34654 9.67532 2.40328 9.58547 2.51677 9.40577C3.45461 7.92078 6.24617 4.16675 10.5003 4.16675C14.7545 4.16675 17.5461 7.92078 18.4839 9.40577C18.5974 9.58547 18.6541 9.67532 18.6859 9.8139C18.7098 9.918 18.7098 10.0822 18.6859 10.1863C18.6541 10.3248 18.5974 10.4147 18.4839 10.5944C17.5461 12.0794 14.7545 15.8334 10.5003 15.8334C6.24617 15.8334 3.45461 12.0794 2.51677 10.5944Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5003 12.5001C11.881 12.5001 13.0003 11.3808 13.0003 10.0001C13.0003 8.61937 11.881 7.50008 10.5003 7.50008C9.11962 7.50008 8.00034 8.61937 8.00034 10.0001C8.00034 11.3808 9.11962 12.5001 10.5003 12.5001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
